import { Sun, Moon, Monitor } from 'lucide-react'
import { useThemeStore } from '../stores/themeStore'
import { useState } from 'react'

/**
 * Theme Toggle Component - Switch between light/dark/auto themes
 */
export function ThemeToggle({ showLabel = false, variant = 'button' }) {
  const { theme, setTheme, toggleTheme } = useThemeStore()
  const [showMenu, setShowMenu] = useState(false)
  
  if (variant === 'simple') {
    return (
      <button
        onClick={toggleTheme}
        className="p-2 rounded-lg hover:bg-blue-500/10 transition-colors"
        title="Wissel thema"
      >
        {theme === 'dark' ? (
          <Moon className="w-5 h-5 text-current" />
        ) : (
          <Sun className="w-5 h-5 text-current" />
        )}
      </button>
    )
  }
  
  return (
    <div className="relative">
      <button
        onClick={() => setShowMenu(!showMenu)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        title="Thema instellen"
      >
        {theme === 'dark' && <Moon className="w-5 h-5 text-gray-700 dark:text-gray-300" />}
        {theme === 'light' && <Sun className="w-5 h-5 text-gray-700 dark:text-gray-300" />}
        {theme === 'auto' && <Monitor className="w-5 h-5 text-gray-700 dark:text-gray-300" />}
        
        {showLabel && (
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {theme === 'dark' && 'Donker'}
            {theme === 'light' && 'Licht'}
            {theme === 'auto' && 'Auto'}
          </span>
        )}
      </button>
      
      {showMenu && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-20 overflow-hidden">
            <button
              onClick={() => {
                setTheme('light')
                setShowMenu(false)
              }}
              className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-left ${
                theme === 'light' ? 'bg-blue-50 dark:bg-blue-900/20' : ''
              }`}
            >
              <Sun className="w-5 h-5 text-yellow-500" />
              <div className="flex-1">
                <div className="font-medium text-gray-900 dark:text-gray-100">Licht</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Licht thema</div>
              </div>
              {theme === 'light' && (
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
              )}
            </button>
            
            <button
              onClick={() => {
                setTheme('dark')
                setShowMenu(false)
              }}
              className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-left ${
                theme === 'dark' ? 'bg-blue-50 dark:bg-blue-900/20' : ''
              }`}
            >
              <Moon className="w-5 h-5 text-blue-600" />
              <div className="flex-1">
                <div className="font-medium text-gray-900 dark:text-gray-100">Donker</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Donker thema</div>
              </div>
              {theme === 'dark' && (
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
              )}
            </button>
            
            <button
              onClick={() => {
                setTheme('auto')
                setShowMenu(false)
              }}
              className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-left ${
                theme === 'auto' ? 'bg-blue-50 dark:bg-blue-900/20' : ''
              }`}
            >
              <Monitor className="w-5 h-5 text-purple-600" />
              <div className="flex-1">
                <div className="font-medium text-gray-900 dark:text-gray-100">Auto</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Systeem voorkeur</div>
              </div>
              {theme === 'auto' && (
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
              )}
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default ThemeToggle
